import { httpClient } from '@/api/http-client'
import { CompanyTaxRegime } from '@/types'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export type CreateCompanyTaxRegimePayload = Omit<
  CompanyTaxRegime,
  'id' | 'company_id'
>

type Params = {
  companyKey: string
  taxRegimeData: CreateCompanyTaxRegimePayload
}

export const createCompanyTaxRegime = async ({
  companyKey,
  taxRegimeData,
}: Params): Promise<CompanyTaxRegime> => {
  const response = await httpClient('accounting-dealer').post<CompanyTaxRegime>(
    `/v3/company/${companyKey}/tax-regime`,
    taxRegimeData,
  )
  return response.data
}

export const useCreateCompanyTaxRegime = (
  options?: UseMutationOptions<CompanyTaxRegime, AxiosError, Params>,
) => {
  return useMutation({
    mutationFn: createCompanyTaxRegime,
    ...options,
  })
}
